const YOUTUBE_ID_REGEXES = [
  /(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|shorts\/|live\/))([\w-]{11})/,
  /youtu\.be\/([\w-]{11})/,
]

export function extractYoutubeVideoId(url) {
  if (!url || typeof url !== 'string') {
    return null
  }
  for (const regex of YOUTUBE_ID_REGEXES) {
    const match = url.match(regex)
    if (match && match[1]) {
      return match[1]
    }
  }
  return null
}

let apiPromise = null

export function loadYoutubeIframeApi() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('YouTube IFrame API requires a browser environment'))
  }
  if (window.YT && window.YT.Player) {
    return Promise.resolve(window.YT)
  }
  if (!apiPromise) {
    apiPromise = new Promise((resolve) => {
      const previousReady = window.onYouTubeIframeAPIReady
      window.onYouTubeIframeAPIReady = () => {
        if (typeof previousReady === 'function') {
          previousReady()
        }
        resolve(window.YT)
      }
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script')
        script.src = 'https://www.youtube.com/iframe_api'
        script.async = true
        document.head.appendChild(script)
      }
    })
  }
  return apiPromise
}
